import { Card, Avatar, Button, Badge, Spin } from 'antd';
import {
  EditOutlined,
  UserOutlined,
  MailOutlined,
  ClockCircleOutlined,
  GlobalOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { ModalAppEditUser } from '../../components/upeosoft/ModalApp/ModalApp';
import { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useQuery } from '@tanstack/react-query';
import { getUserDetails } from '../../network/dashboard';
import { useSelector } from 'react-redux';

const UserView = ({ t }) => {
  const [open, setOpen] = useState(false);
  const { data } = useSelector((state) => state.user);
  //   console.log('data:', data);
  const { data: user, isLoading } = useQuery({
    queryKey: [queryKeys.getUserDetails, data?.email],
    queryFn: () => getUserDetails(data?.email),
  });
  const {
    enabled,
    email,
    first_name,
    last_name,
    full_name,
    username,
    language,
    time_zone,
    gender,
    desk_theme,
    banner_image,
    new_password,
    logout_all_sessions,
    last_ip,
    last_active,
    last_login,
  } = user?.data || {};

  return (
    <div className="flex justify-center items-center  p-6">
      <Card className="!max-w-5xl w-full p-2 bg-white shadow-xl rounded-xl ">
        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <Spin />
          </div>
        ) : (
          <div className="">
            <div className="flex items-center justify-between border-b pb-4 mb-4">
              <div className="flex items-center gap-4">
                {/* <Avatar
              size={90}
              src={userData.image}
              className="border-2 border-blue-500 shadow-md"
            /> */}
                {data?.image ? (
                  <img
                    src={`https://elegant.technolead.co${data?.image}`}
                    alt=""
                  />
                ) : (
                  <Avatar
                    size={90}
                    className="border-2 border-blue-500 shadow-md"
                  />
                )}
                <div>
                  <h2 className="text-2xl font-bold">{full_name}</h2>
                  <p className="text-gray-500 flex items-center gap-2">
                    <MailOutlined /> {email}
                  </p>
                  <Badge
                    status={enabled ? 'success' : 'error'}
                    text={enabled ? 'Active' : 'Inactive'}
                    className="mt-1"
                  />
                </div>
              </div>
              <Button
                type="primary"
                icon={<EditOutlined />}
                size="large"
                onClick={() => setOpen(true)}
              >
                Edit
              </Button>
            </div>

            {/* User Details */}
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 flex items-center gap-2">
                  <UserOutlined />{' '}
                  <span className="font-medium">Username:</span> {username}
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 flex items-center gap-2">
                  <GlobalOutlined />{' '}
                  <span className="font-medium">Language:</span>{' '}
                  {language === 'en' ? 'English' : 'العربية'}
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 flex items-center gap-2">
                  <ClockCircleOutlined />{' '}
                  <span className="font-medium">Time Zone:</span> {time_zone}
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 flex items-center gap-2">
                  <UserOutlined /> <span className="font-medium">Gender:</span>{' '}
                  {gender}
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 flex items-center gap-2">
                  <ClockCircleOutlined />{' '}
                  <span className="font-medium">Last Active:</span>{' '}
                  {last_active}
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 flex items-center gap-2">
                  <ClockCircleOutlined />{' '}
                  <span className="font-medium">Last Login:</span> {last_login}
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 flex items-center gap-2">
                  <GlobalOutlined />{' '}
                  <span className="font-medium">Last IP:</span> {last_ip}
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 flex items-center gap-2">
                  <LogoutOutlined />{' '}
                  <span className="font-medium">Logout All Sessions:</span>
                  <Badge
                    status={logout_all_sessions ? 'success' : 'default'}
                    text={logout_all_sessions ? 'Yes' : 'No'}
                  />
                </p>
              </div>
            </div>
          </div>
        )}
      </Card>
      <ModalAppEditUser open={open} setOpen={setOpen} t={t} />
    </div>
  );
};

export default UserView;
